export default {
    termsAndConditions: {
        title: 'Terms & Conditions'
    }
};
